import {
  CREATE_PVS_SUBCATEGORY_REQUEST,
  CREATE_PVS_SUBCATEGORY_SUCCESS,
  CREATE_PVS_SUBCATEGORY_FAILURE,
  RESET_PVS_SUBCATEGORY_STATE,
} from '../../../types/pvs';

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",   // 🔹 added message
};

const createPvsCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_PVS_SUBCATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      };

    case CREATE_PVS_SUBCATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload?.message || "Subcategory created successfully!", // 🔹 added
      };

    case CREATE_PVS_SUBCATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        success: false,
        message: action.payload?.message || "Failed to create subcategory", // 🔹 added
      };

    case RESET_PVS_SUBCATEGORY_STATE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default createPvsCategoryReducer;
